
// #region imports

// #region vue
import { Component, Prop, Vue } from 'vue-property-decorator'
// #endregion

// #region services
import settingService from '@/services/setting.service'
// #endregion

// #region interfaces
import { CompanySettingInterface } from '@/types/interfaces/setting'
// #endregion

// #region validation
import rules from '@/utils/rules.utils'
// #region

// #region components
import PageHeader from '@/common/components/pages/PageHeader.vue'
import PageOverview from '@/common/components/pages/PageOverview.vue'
import EmailReminder from '@/containers/settings/notifications/EmailReminder.vue'
import EmailSubscription from '@/containers/settings/notifications/EmailSubscription.vue'
import EmailUpdate from '@/containers/settings/notifications/EmailUpdate.vue'
import EmailConfirmation from '@/containers/settings/notifications/EmailConfirmation.vue'
import EmailSurvey from '@/containers/settings/notifications/EmailSurvey.vue'
// #endregion

// #region locales
import i18n from '@/i18n'
// #endregion

// #endregion

@Component({
  components: {
    PageHeader,
    PageOverview,
    EmailReminder,
    EmailSubscription,
    EmailUpdate,
    EmailConfirmation,
    EmailSurvey
  }
})
export default class EmailNotificationSettings extends Vue {
  @Prop({ required: true }) readonly selectedCompany!: string
  @Prop({ required: true }) readonly data!: CompanySettingInterface
  @Prop({ required: true }) readonly setData!: (
    data: CompanySettingInterface
  ) => void

  rules = rules

  tab = 'email_reminder'

  items = [
    {
      key: 'email_reminder',
      label: `${i18n.t('common.email')} ${i18n.t('common.reminder')}`
    },
    {
      key: 'email_update',
      label: `${i18n.t('common.email')} ${i18n.t('settings.update')}`
    },
    {
      key: 'email_confirmation',
      label: `${i18n.t('common.email')} ${i18n.t('settings.confirmation')}`
    },
    {
      key: 'email_survey',
      label: `${i18n.t('common.email')} ${i18n.t('settings.survey')}`
    }
  ]

  async fetchSettings (): Promise<void> {
    const result = await settingService.getCompanySettings(this.selectedCompany)
    this.setData(result)
  }

  async toggleNotificationSettings (setting: string): Promise<void> {
    await settingService.toggleNotificationSetting(
      this.selectedCompany,
      setting
    )

    await this.fetchSettings()
  }
}
